module.exports = __webpack_public_path__ + "img/video_overlay.238f7c70.png";